export default __webpack_public_path__ + "static/media/success.bec69105.gif";